import { userName, userID, eventID } from "../../utils/datalayer"
import Leaderboard from "src/components/Leaderboard"

const Floating = ({ component }) => <div class= "dropdown-contenttk2">
	{component}
</div>


export const Navbar = () => {

	return <div class="topnavtk2" id="myTopnavtk2">
		<a href = "https://event.dev.tkevents.io/" id="LeaveEvent" class="activetk2">Leave</a>
		<div class="dropdowntk2">
			<button class="dropbtntk2">Venue
				<i class="fa fa-caret-down" />
			</button>
			<div class="dropdown-contenttk2">
				<a href="/" title="Return to Lobby">Lobby</a>
				<a href="/Main-Stage" title="The Lounge">Main Stage</a>

				<a href="/Breakouts" title="The Lounge">Breakouts</a>
				<a href="/Entertainment-Lounge" title="The Lounge">Entertainment Lounge</a>
				<a href="/Expert-Lounge" title="Expert Lounge">Expert Lounge</a>
				<a href="/Expo-Hall" title="Expo Hall">Expo Hall</a>
				<a href="/BYOB" title="Dev Booths">Platinum Booths</a>
				<a href="/Management-Booths" title="Booths">Wooden Booths</a>
				<a href="/Workshop" title="Workshop">Workshop</a>
				<a href="/Roundtables" title="Roundtables">Roundtables</a>
			</div>
		</div>
		<div>
			<div class="dropdowntk2">
				<button  class="dropbtntk2">Leaderboard
					<i class="fa fa-caret-down" />
				</button>
				<Floating component={
					<Leaderboard
						userId={userID}
						eventId={eventID}
						name={userName}
						hideClose={true}
						entrypoint="https://leaderboardb.swoogo-retrofit.tkevents.io"
						poolingSec={3}
					/>
				} />
			</div>
		</div>

		<a onclick={window.openSupport} title="Help Desk">Help Desk</a>
	</div>
}
